import type { RouteObject } from "react-router-dom";
import PageForbidden from "./pages/forbidden/PageForbidden";
import PageNotFound from "./pages/not-found/PageNotFound";
import { homeRoutes } from "@/pages/home/routes";
import { sandboxRoutes } from "@/pages/sandbox/routes";
import { haccpRoutes } from "@/pages/haccp/routes";
import { managementRoutes } from "@/pages/management/routes.tsx";
import { humanResourcesRoutes } from "@/pages/human-resources/routes";

export default function routes(): RouteObject[] {
  return [
    ...homeRoutes,
    ...sandboxRoutes,
    ...haccpRoutes,
    ...managementRoutes,
    ...humanResourcesRoutes,
    // Default pages -----------------------------------------------------------
    {
      path: "/forbidden",
      element: <PageForbidden />,
    },
    {
      path: "*",
      element: <PageNotFound />,
    },
  ];
}
